// DS: C59M
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { useTranslation } from 'react-i18next';
import MobileSharePopup from './MobileSharePopup';
import { getDeviationShareCodes } from '../helpers';
import { getTranslatedDeviationTitle, getDeviationResourceType } from '../../DeviationViews/_helpers';
const MobileDeviationSharePopup = ({ deviation , requestClose  })=>{
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement(MobileSharePopup, _extends({
        title: getTranslatedDeviationTitle(deviation, t),
        requestClose: requestClose,
        biData: {
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId
        }
    }, getDeviationShareCodes(deviation)));
};
MobileDeviationSharePopup.displayName = 'MobileDeviationSharePopup';
export default MobileDeviationSharePopup;
